module.exports = __webpack_public_path__ + "img/c1-pop2.fc546b2d.png";